import axios from 'axios'
import { PointSystem } from '../models/leaderboards/PointSystem';
import { Match } from '../models/Match';
import { Tournament } from '../models/Tournament';

export async function fetchPastTournaments(): Promise<Array<Tournament>> {
    try {
        const response = await axios.get(`/pubg/tournament/past`)
        return response.data.map((tourney: any) => {
            var pointSystem: PointSystem | undefined = undefined
            if (tourney.placement !== null)  {
                pointSystem = JSON.parse(tourney.placement)
            }
            
            return {
                name: tourney.name,
                type: tourney.type,
                tournamentid: tourney.tournamentid,
                date: tourney.date,
                active: tourney.active,
                placement: pointSystem,
                completed: tourney.completed,
                bounties: tourney.bounties,
            }
        })
    } catch (e: any) {
        if (e.response) {
            throw e.response
        } else {
            throw e.message;
        }
    }

}

export async function fetchActiveTournament(): Promise<Tournament> {
    try {
        const response = await axios.get(`/pubg/tournament/active`)
        // console.log(response.data[0])
        var pointSystem: PointSystem | undefined = undefined
        if (response.data[0].placement !== null)  {
            pointSystem = JSON.parse(response.data[0].placement)
        }
        
        return {
            name: response.data[0].name,
            type: response.data[0].type,
            tournamentid: response.data[0].tournamentid,
            date: response.data[0].date,
            active: response.data[0].active,
            placement: pointSystem,
            completed: response.data[0].completed,
            bounties: response.data[0].bounties,
        }
    } catch (e: any) {
        if (e.response) {
            throw e.response
        } else {
            throw e.message;
        }
    }
}

export async function fetchTournamentMatches(tournamentId: number): Promise<Array<Match>> {
    try {
        const response = await axios.get(`/pubg/tournament/${tournamentId}/matches`)
        return response.data
    } catch (e: any) {
        if (e.response) {
            throw e.response
        } else {
            throw e.message;
        }
    }
}
